import { Link } from "@inertiajs/react"
import { Menu } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Logo } from "@/components/logo"
import { useSidebar } from "@/components/ui/sidebar"

export function MobileSidebarTrigger() {
  const { toggleSidebar } = useSidebar()

  return (
    <div className="flex items-center justify-between px-4 py-2 border-b md:hidden">
      <Link href="/">
        <Logo className="h-5" />
      </Link>
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9"
        onClick={toggleSidebar}
      >
        <Menu className="h-5 w-5" />
        <span className="sr-only">Toggle menu</span>
      </Button>
    </div>
  )
}
